module.exports = __webpack_public_path__ + "img/IMG_1454_L_Foamcore.cf0eab32.jpg";